import * as React from "react";
import Svg, { Path } from "react-native-svg";

function BankDetailsGraphic(props) {
  return (
    <Svg width={312} height={189} viewBox="0 0 312 189" fill="none" {...props}>
      <Path
        d="M.448 10.298c0 19.484 12.167 35.25 27.202 35.25L.448 10.298z"
        fill="#46455B"
      />
      <Path
        d="M27.65 45.548c0-19.703 13.578-35.646 30.357-35.646L27.65 45.548zM10.304 12.064c0 18.508 7.758 33.484 17.346 33.484L10.304 12.064z"
        fill="#FFB800"
      />
      <Path
        d="M27.65 45.548C27.65 20.372 43.345 0 62.739 0L27.65 45.548z"
        fill="#46455B"
      />
      <Path
        d="M242.544 52.672H23.398c-4.884 0-8.843 3.977-8.843 8.884v117.062c0 4.906 3.96 8.883 8.843 8.883h219.146c4.883 0 8.842-3.977 8.842-8.883V61.555c0-4.906-3.959-8.883-8.842-8.883z"
        fill="#E40046"
      />
      <Path
        d="M246.616 71.674H9.786V90.51h236.83V71.674zM221.232 152.637H44.379c-.939 0-1.7.765-1.7 1.709v5.836c0 .943.761 1.708 1.7 1.708h176.853c.94 0 1.701-.765 1.701-1.708v-5.836c0-.944-.761-1.709-1.701-1.709z"
        fill="#fff"
      />
      <Path
        d="M247.806 45.402H28.66c-4.883 0-8.842 3.977-8.842 8.883v117.063c0 4.906 3.959 8.883 8.842 8.883h219.146c4.884 0 8.843-3.977 8.843-8.883V54.285c0-4.906-3.959-8.883-8.843-8.883z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M256.484 65.725H19.654v18.837h236.83V65.725z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M55.258 113.312h-24.5a2.888 2.888 0 00-2.881 2.894v19.327a2.888 2.888 0 002.88 2.894h24.5a2.888 2.888 0 002.882-2.894v-19.327a2.888 2.888 0 00-2.881-2.894z"
        fill="#FFB800"
      />
      <Path
        d="M58.876 109.016h-24.5a2.888 2.888 0 00-2.88 2.894v19.327a2.887 2.887 0 002.88 2.894h24.5c1.591 0 2.88-1.295 2.88-2.894V111.91a2.888 2.888 0 00-2.88-2.894zM226.495 148.011H49.642c-.939 0-1.7.765-1.7 1.708v5.836c0 .944.761 1.709 1.7 1.709h176.853c.94 0 1.701-.765 1.701-1.709v-5.836c0-.943-.761-1.708-1.701-1.708zM0 187.501h281.81"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M309.781 147.649l-7.944 7.636a1.504 1.504 0 01-1.98.094 109.8 109.8 0 01-20.259-21.273 1.52 1.52 0 01.181-1.983l7.994-7.683a1.492 1.492 0 011.188-.413 1.512 1.512 0 011.086.636c5.834 8.371 12.293 15.399 19.572 20.666a1.505 1.505 0 01.525 1.773 1.507 1.507 0 01-.363.547z"
        fill="#F2F2F2"
      />
      <Path
        d="M310.535 145.095l-7.944 7.636a1.499 1.499 0 01-1.979.094 109.865 109.865 0 01-20.26-21.273 1.524 1.524 0 01.182-1.983l7.993-7.683a1.5 1.5 0 012.274.223c5.834 8.371 12.293 15.398 19.573 20.665a1.525 1.525 0 01.622 1.123 1.517 1.517 0 01-.461 1.198v0z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M299.088 142.834c1.051-1.009.375-3.431-1.509-5.409-1.884-1.978-4.262-2.763-5.312-1.754-1.051 1.009-.375 3.431 1.509 5.409 1.884 1.978 4.262 2.764 5.312 1.754z"
        fill="#E40046"
      />
      <Path
        d="M298.892 141.194c1.05-1.01.374-3.432-1.51-5.41-1.884-1.978-4.262-2.763-5.312-1.754-1.05 1.01-.374 3.431 1.509 5.41 1.884 1.978 4.263 2.763 5.313 1.754z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M304.742 120.836l-1.673 10.917a1.512 1.512 0 01-1.513 1.286 109.055 109.055 0 01-28.964-4.48 1.509 1.509 0 01-.843-.642 1.52 1.52 0 01-.215-1.042l1.683-10.984a1.52 1.52 0 01.692-1.055 1.512 1.512 0 011.248-.16c9.701 3.071 19.084 4.694 28.05 4.418a1.5 1.5 0 011.491 1.085c.063.213.077.437.044.657z"
        fill="#F2F2F2"
      />
      <Path
        d="M303.792 118.348l-1.673 10.917a1.515 1.515 0 01-.516.928 1.501 1.501 0 01-.997.358 109.094 109.094 0 01-28.964-4.479 1.517 1.517 0 01-1.058-1.684l1.683-10.985a1.513 1.513 0 011.299-1.271c.215-.028.434-.008.641.057 9.701 3.071 19.084 4.693 28.051 4.417a1.514 1.514 0 011.174.51 1.513 1.513 0 01.36 1.232z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M293.342 123.558c.221-1.443-1.783-2.95-4.476-3.367-2.693-.416-5.056.416-5.277 1.859-.221 1.443 1.783 2.951 4.476 3.367 2.693.417 5.056-.416 5.277-1.859z"
        fill="#E40046"
      />
      <Path
        d="M292.192 122.377c.221-1.443-1.783-2.95-4.476-3.367-2.694-.416-5.056.416-5.277 1.859-.221 1.443 1.783 2.951 4.476 3.367 2.693.417 5.056-.415 5.277-1.859z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M257.406 31.613c3.12 0 5.649-2.541 5.649-5.676 0-3.135-2.529-5.677-5.649-5.677-3.121 0-5.65 2.542-5.65 5.677s2.529 5.676 5.65 5.676z"
        fill="#2F2E41"
      />
      <Path
        d="M262.419 28.885a5.694 5.694 0 00-.918-7.614 5.68 5.68 0 012.696 3.957 5.695 5.695 0 01-.98 4.231 5.63 5.63 0 01-8.268 1.006 5.627 5.627 0 004.041.67 5.647 5.647 0 003.429-2.25z"
        fill="#2F2E41"
      />
      <Path
        d="M256.668 48.395c5.698 0 10.318-4.64 10.318-10.365 0-5.725-4.62-10.366-10.318-10.366-5.698 0-10.317 4.641-10.317 10.366 0 5.724 4.619 10.365 10.317 10.365z"
        fill="#2F2E41"
      />
      <Path
        d="M258.634 53.824c0-.246-1.966-1.974-1.966-1.974s-9.826-2.715-11.791-.74a3.585 3.585 0 00-.737 4.196l9.089 2.714 5.405-4.196z"
        fill="#3F3D56"
      />
      <Path
        d="M257.283 47.531s-2.211 6.17 0 6.664c2.211.493-11.791 2.714-11.791 2.714l-2.211-4.195s7.615-3.949 6.632-9.378l7.37 4.195z"
        fill="#FBBEBE"
      />
      <Path
        opacity={0.1}
        d="M257.283 47.531s-2.211 6.17 0 6.664c2.211.493-11.791 2.714-11.791 2.714l-2.211-4.195s7.615-3.949 6.632-9.378l7.37 4.195z"
        fill="#000"
      />
      <Path
        d="M232.205 66.785l1.154 15.536s-.637 11.55 1.822 22.17c0 0-.224 12.739 3.979 12.651 4.204-.088.651-15.04.651-15.04l-.706-32.043-6.9-3.274zM272.267 66.534l.983 15.548s2.211 11.353 1.228 22.212c0 0 1.965 12.586-2.211 13.08-4.176.493-2.702-14.808-2.702-14.808L265.88 70.73l6.387-4.196z"
        fill="#FBBEBE"
      />
      <Path
        d="M252.37 113.178s2.21 25.666 1.474 27.147c-.737 1.481 0 28.135 0 28.135s.736 10.118.245 10.118-4.667-1.481-4.667-1.481-3.194-12.586-3.931-15.054c-.736-2.468-.736-15.054-.736-20.237 0-5.183-4.913-26.654-4.913-26.654l12.528-1.974z"
        fill="#FBBEBE"
      />
      <Path
        opacity={0.1}
        d="M252.37 113.178s2.21 25.666 1.474 27.147c-.737 1.481 0 28.135 0 28.135s.736 10.118.245 10.118-4.667-1.481-4.667-1.481-3.194-12.586-3.931-15.054c-.736-2.468-.736-15.054-.736-20.237 0-5.183-4.913-26.654-4.913-26.654l12.528-1.974z"
        fill="#000"
      />
      <Path
        d="M247.948 177.344s3.93-2.468 4.913-.987a9.639 9.639 0 001.965 2.221l.491 8.237s-2.864-.385-3.356.356c-.491.74-4.259 1.279-6.715.292-2.457-.987 0-5.676 0-5.676l2.702-4.443z"
        fill="#2F2E41"
      />
      <Path
        d="M269.339 109.818s-.265 8.296-3.459 13.972c-3.193 5.676-6.878 10.366-6.386 14.808.491 4.442 3.684 2.715 1.719 21.471 0 0-1.228 7.65 0 11.599s-5.895 2.468-5.895 2.468-1.229-16.288-2.211-18.509c-.983-2.222-5.159-17.029-3.685-23.199 1.474-6.17 5.896-22.211 5.896-22.211l14.021-.399z"
        fill="#FBBEBE"
      />
      <Path
        d="M255.809 170.434s3.439.247 4.422.494a1.36 1.36 0 001.473-.494s1.229 7.651 1.966 9.378c.737 1.728-.737 6.664-4.422 6.664-3.685 0-4.667-2.222-4.667-2.962v-9.625l-.246-2.221s1.474-.494 1.474-1.234z"
        fill="#2F2E41"
      />
      <Path
        d="M256.177 49.629c4.884 0 8.843-3.978 8.843-8.885s-3.959-8.884-8.843-8.884-8.843 3.977-8.843 8.884 3.959 8.885 8.843 8.885z"
        fill="#FBBEBE"
      />
      <Path
        d="M256.668 51.85s.123 3.085-4.79 2.344c-4.913-.74-7.124-2.961-7.124-2.961s-10.808 1.974-11.545 6.17c-.737 4.195 4.667 10.612 4.667 10.612s0 4.442.737 6.17c.737 1.727-3.439 15.054-.737 15.794 2.702.74 4.422.74 9.826 1.975 5.404 1.234 11.054 1.48 12.774 0 1.719-1.481 4.176-1.975 5.896-1.975 1.719 0 2.947-2.714 1.719-3.948s-2.456-4.443-2.456-5.677c0-1.233 1.719-5.922.737-7.65l3.193-17.029s-3.439-2.714-5.404-2.961a910.247 910.247 0 00-7.493-.864z"
        fill="#FFB800"
      />
      <Path
        d="M267.6 55.428l1.842.124s5.282 12.463 4.054 13.203c-1.229.74-7.861 4.196-8.598 3.949-.737-.247 2.702-17.275 2.702-17.275zM235.666 56.416l-2.088.123s-2.088 11.723-2.334 12.463c-.246.74 8.106 4.196 8.843 3.702.737-.493-4.421-16.288-4.421-16.288z"
        fill="#FFB800"
      />
      <Path
        d="M265.88 88.252l2.659 5.445s2.805 18.048.933 18.271c-1.872.223-13.172-1.011-14.4.716-1.228 1.728-2.211 1.975-2.211 1.975s-13.019 2.715-14.493.987c-1.474-1.728 0-24.186 1.719-25.913 0 0 12.037 2.961 13.757 1.727 1.719-1.234 12.036-3.208 12.036-3.208zM261.534 33.179c.141.085.279.174.414.265a10.274 10.274 0 00-7.619-.875 10.322 10.322 0 00-6.115 4.649 10.406 10.406 0 00-1.233 7.604 10.363 10.363 0 004.332 6.358 10.364 10.364 0 01-5.109-6.626 10.407 10.407 0 011.178-7.84 10.32 10.32 0 016.348-4.71c2.653-.662 5.46-.24 7.804 1.175z"
        fill="#2F2E41"
      />
      <Path
        d="M251.067 33.179c-.142.085-.279.174-.415.265a10.274 10.274 0 017.619-.875 10.322 10.322 0 016.115 4.649 10.402 10.402 0 011.233 7.604 10.366 10.366 0 01-4.331 6.358 10.364 10.364 0 005.108-6.626 10.407 10.407 0 00-1.178-7.84 10.321 10.321 0 00-6.347-4.71 10.275 10.275 0 00-7.804 1.175z"
        fill="#2F2E41"
      />
      <Path
        d="M256.668 41.485c5.156 0 9.335-2.652 9.335-5.923s-4.179-5.923-9.335-5.923c-5.155 0-9.334 2.652-9.334 5.923 0 3.27 4.179 5.923 9.334 5.923z"
        fill="#2F2E41"
      />
    </Svg>
  );
}

export default BankDetailsGraphic;
